import { render, staticRenderFns } from "./InfrastructureSection.vue?vue&type=template&id=87b5c7e4&scoped=true"
import script from "./InfrastructureSection.vue?vue&type=script&lang=js"
export * from "./InfrastructureSection.vue?vue&type=script&lang=js"
import style0 from "./InfrastructureSection.vue?vue&type=style&index=0&id=87b5c7e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b5c7e4",
  null
  
)

export default component.exports